<template functional>
<v-layout class="relation-card-collapsed"
          :class="{ dark: props.dark }"
          justify-center align-center v-on="{ click: listeners.click }">
  <v-flex shrink :class="{'error': props.error}">
    <v-img v-if="props.image" :height="60" :width="60" :src="props.image" />
    <v-responsive v-else :height="60" :width="60">
      <v-layout align-center fill-height justify-center>
        <v-icon v-if="props.error" color="white">report_problem</v-icon>
        <v-icon v-else color="primary" v-text="props.icon || 'mode'"></v-icon>
      </v-layout>
    </v-responsive>
  </v-flex>
  <v-flex class="relation-card-collapsed__title"
          :class="{'relation-card-collapsed__title--error': props.error}"
          v-text="props.title || parent.$t('message.relation.editElement')" />
  <slot name="actions"></slot>
  <v-flex v-if="props.draggable" shrink class="relation-card-collapsed__drag-handle nx-drag-handle">
    <v-icon class="mr-2" color="primary">drag_handle</v-icon>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  name: 'nx-relation-card-collapsed',
  props: {
    title: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    image: {
      type: String,
    },
    icon: {
      type: String,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    dark: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables.styl";

.relation-card-collapsed {
  background-color: $nx-primary--lighten-5;
  border-radius: 1px;
  cursor: pointer;

  &__title {
    font-size: 16px;
    color: $nx-primary--darken-3;
    padding: 0 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &--error {
      color: $error;
    }
  }

  &__drag-handle {
    cursor: grab;
  }

  &.dark {
    background-color: $white;
  }
}
</style>
